const addProgressReducer = (data = {}, action) => {
    switch(action.type){
        case 'SET_ADD_PROGRESS':
            data = action.data
            return data;
        default:
            return data;
    }
}

export default addProgressReducer;